module.exports = __webpack_public_path__ + "img/ABC.b9ab4ed9.png";